import { mainSearch } from "../../components/indexDB/indexDBStora";
import { CurrentTime } from "../current";

export async function validationInventory(product, isValidateBatch = true) {

    const res = {
        success: false,
        message: ""
    };

    if (!product) {
        res.message = "Product data is required";
        return res;
    }

    // check productId
    if (!product.productId) {
        res.message = "Product is required";
        return res;
    }

    // buy price validation
    if (isNaN(product.buyPrice) || product.buyPrice <= 0) {
        res.message = "Buy price must be a valid number greater than zero";
        return res;
    }


    // batch validation
    if (isValidateBatch && !product.batchId) {
        res.message = "batchId not found";
        return res;
    }

    // expiration validation
    const current = CurrentTime(false, true);

    const isValidDate =
        product.meta?.expiredDate &&
        new Date(product.meta.expiredDate) > new Date(current);

    if (!isValidDate) {
        res.message = "Please enter a valid expiration date";
        return res;
    }

    // supplier validation
    if (!product.meta?.supplierId) {
        res.message = "Please choose supplier";
        return res;
    }

    const supplier = await mainSearch("suppliers", product.meta.supplierId);

    if (!supplier) {
        res.message = "Invalid supplier";
        return res;
    }

    res.success = true;
    res.message = "Validation passed";
    return res;
}